module.exports = __webpack_public_path__ + "media/spa/flow_step_02-1f14a04d.svg";